import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles(() =>
  createStyles({
    completedLabel: {
      position: 'absolute',
      textTransform: 'uppercase',
      fontSize: 14,
      fontWeight: 700,
      right: 9,
      bottom: SMALL_MARGIN,
      color: 'rgba(255, 255, 255, .3)',
      zIndex: 1,
    },
  }),
);
export default useStyles;
